import { DEFAULT_LLM_MODEL_KEY } from '../../constants/llmModels';
export {
  buildProjectBootstrapMessage,
  buildDefaultFollowUpPrompt,
  DEFAULT_FOLLOW_UP_PROMPT,
  GENERATED_APP_STACK
} from '../../utils/projectGenerationPrompts';

export const emptyCreateForm = {
  name: '',
  description: '',
  visibility: 'your',
  model: DEFAULT_LLM_MODEL_KEY,
  enableDatabase: false,
  enableAuth: false,
  registrationEnabled: true
};

export const buildCreateFeatures = ({ enableDatabase, enableAuth, registrationEnabled } = {}) => {
  const features = [];

  if (enableDatabase) {
    features.push({ key: 'database' });
  }

  if (enableAuth) {
    features.push({
      key: 'auth',
      metadata: { registrationEnabled: Boolean(registrationEnabled) }
    });
  }

  return features;
};

export const createProjectNameFromPrompt = (prompt, language = 'fa') => {
  const fallback = language === 'fa' ? 'پروژه جدید AI' : 'New AI Project';
  const trimmed = String(prompt || '').trim();

  if (!trimmed) {
    return fallback;
  }

  const sanitized = trimmed.replace(/["'،,.!؟]/g, ' ').replace(/\s+/g, ' ').trim();
  const words = sanitized.split(' ').filter(Boolean);
  const preview = words.slice(0, 5).join(' ');
  const suffix = words.length > 5 ? '...' : '';

  return preview ? `${preview}${suffix}` : fallback;
};

export const buildEditForm = (project) => ({
  name: project?.name || '',
  description: project?.description || '',
  visibility: project?.visibility || 'your',
  sortOrder: String(project?.sortOrder ?? 0),
  categoryIds: (project?.categories || []).map((category) => category.id).filter(Boolean),
  coverImageUrl: project?.coverImageUrl || project?.coverImage || '',
  coverImageFile: null
});

export const mergeCategories = (available, projectCategories = []) => {
  const map = new Map();

  [...available, ...projectCategories].forEach((category) => {
    if (category?.id) {
      map.set(category.id, category);
    }
  });

  return Array.from(map.values()).sort((first, second) => first.name.localeCompare(second.name));
};
